// import "./Landing.scss";
import Header from "../components/Header/HeaderMain";
import Nav from "../components/Nav/Nav";
import Block from "../components/Block/Block";
import Footer from "../components/Footer/Footer";
import Marquee from "../components/Marquee/Marquee";
import TeamPhoto from "../assets/versusteamride.webp";
import RiderImage from "../assets/juliaupdated.webp";

const Landing = () => {
  return (
    <div className="Landing_page">
      <Marquee />
      <Header />
      <Nav />
      <Block
        header="Get involved"
        text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        image={RiderImage}
        alt="team photo"
        color="pink"
        order="right"
        id="about"
      />
      <Block
        header="What we are about"
        text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        image={TeamPhoto}
        alt="team photo"
        color="purple"
        order="left"
      />
      <Footer />
    </div>
  );
};

export default Landing;
